// extracted by mini-css-extract-plugin
export default {"detailsUserLocalTabView":"UserLocalGridPluginView_detailsUserLocalTabView__mPKJF","userLocalFlexRow":"UserLocalGridPluginView_userLocalFlexRow__DfJJS"};